<template>
  <v-dialog v-model="dialog" persistent width="50%">
    <v-btn color="secondary" dark slot="activator">
      <v-icon small>$vuetify.icons.rms_create</v-icon>
      {{ $t('rms.button.create') }}
    </v-btn>
    <v-card class="pa-3">
      <v-card-title primary-title>
        <div class="title">{{ $t('venue.create.dialog.title') }}</div>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0"
          small
          dark
          icon
          color="grey"
          @click.native="reset()"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" onsubmit="return false;">
          <v-text-field
            id="name"
            :label="$t('venue.form.label.name')"
            name="name"
            :rules="[
              rules.required,
              rules.min_length(3),
              rules.max_length(250),
            ]"
            counter="250"
            color="primary"
            prepend-icon="$vuetify.icons.rms_agreement"
            type="text"
            v-model="venue.name"
          ></v-text-field>
          <v-text-field
            id="subtitle"
            :label="$t('venue.form.label.subtitle')"
            name="subtitle"
            color="primary"
            prepend-icon="$vuetify.icons.rms_agreement"
            type="text"
            v-model="venue.subtitle"
          ></v-text-field>
          <v-text-field
            id="address"
            :label="$t('venue.form.label.address')"
            name="address"
            :rules="[
              rules.required,
              rules.min_length(3),
              rules.max_length(250),
            ]"
            color="primary"
            prepend-icon="$vuetify.icons.rms_agreement"
            type="text"
            v-model="venue.address"
          ></v-text-field>
          <!-- <v-layout row wrap>
            <v-flex xs6>
              <v-text-field
                id="rows"
                :label="$t('venue.form.label.rows')"
                name="rows"
                :rules="[rules.required, rules.numeric]"
                color="primary"
                prepend-icon="$vuetify.icons.rms_agreement"
                type="number"
                v-model="venue.rows"
              ></v-text-field>
              <v-select
                v-model="venue.label_type_row"
                :items="DEFINES.SEAT_LABELLING_TYPES_ARRAY"
                :label="$t('venue.form.label.label_type_row')"
                item-text="text"
                item-value="value"
                hide-details
                color="saSecondary"
                prepend-icon="$vuetify.icons.rms_agreement"
              ></v-select>
              <v-checkbox
                :label="$t('venue.form.label.is_label_row_reversed')"
                v-model="venue.is_label_row_reversed"
              ></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                id="columns"
                :label="$t('venue.form.label.columns')"
                name="columns"
                :rules="[rules.required, rules.numeric]"
                color="primary"
                prepend-icon="$vuetify.icons.rms_agreement"
                type="number"
                v-model="venue.columns"
              ></v-text-field>
              <v-select
                v-model="venue.label_type_column"
                :items="DEFINES.SEAT_LABELLING_TYPES_ARRAY"
                :label="$t('venue.form.label.label_type_column')"
                item-text="text"
                item-value="value"
                hide-details
                color="saSecondary"
                prepend-icon="$vuetify.icons.rms_agreement"
              ></v-select>
              <v-checkbox
                :label="$t('venue.form.label.is_label_column_reversed')"
                v-model="venue.is_label_column_reversed"
              ></v-checkbox>
            </v-flex>
          </v-layout> -->
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="grey" outline @click.native="reset()">
          {{ $t('reminder.dialog.box.button.close') }}
        </v-btn>
        <v-btn color="primary"
        outline
        :loading="loading"
        :disabled="loading"
        @click.prevent="create()">
        {{ $t('film.delivery_profile.button.create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import rules from '@/validation';
import { mapGetters} from 'vuex';

export default {
  name: 'VenueCreatDialog',

  data() {
    return {
      rules,
      dialog: false,
      venue: {},
      loading:false
    };
  },

  computed: {
    ...mapGetters('company', {
      selected_company_id: 'getSelected',
      timezone: 'getSelectedCompanyTimezone',
    }),
  },
  created() {
    this.venue = this.initiateDefaultVenue();
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      // if (this.venue.label_type_column == this.venue.label_type_row) {
      //   this.$store.dispatch('app/showMessage', {
      //     message: this.$t(
      //       'venue.save.error.row_and_column_labelling_can_not_same'
      //     ),
      //     color: 'error',
      //   });
      //   return;
      // }
      this.loading = true;
      var response = await this.$store
        .dispatch('venue/create', this.venue)
        .then((res) => {
          this.$store.dispatch('venue/list');
          this.$router.push({
            name: 'venue.update',
            params: {
              company_id: this.selected_company_id,
              venue_id: res.result.id,
            },
          });
          this.$store.dispatch('app/showMessage', {
            message: this.$t('venue.created.successfully'),
            color: 'success',
          });
        })
        .catch((error) => {
          this.$store.dispatch('app/showMessage', {
            message: error.message,
            color: 'error',
          });
        })
        .finally(()=>{
          this.loading = false;
        });
    },

    initiateDefaultVenue() {
      let rows = this.DEFINES.STATIC_SEATS_COMPANY_IDS.includes(this.selected_company_id) ? 24 : null;
      let columns = this.DEFINES.STATIC_SEATS_COMPANY_IDS.includes(this.selected_company_id) ? 39 : null;
      console.log(rows, columns);
      
      return {
        name: null,
        address: null,
        rows: rows,
        columns: columns,
        is_published: false,
        label_type_row: this.DEFINES.SEAT_LABELLING_TYPE.ALPHABETS,
        label_type_column: this.DEFINES.SEAT_LABELLING_TYPE.NUMERIC,
        is_label_row_reversed: false,
        is_label_column_reversed: false,
        not_for_sale: null,
        created_by: null
      };
    },
    reset() {
      this.dialog = false;
      this.venue = this.initiateDefaultVenue();
    },
  },
};
</script>
